// Rebranche la fermeture du tiroir sur clic hors panneau (overlay).
// Dawn attache cet écouteur au constructor de <cart-drawer> et dans renderContents(),
// mais toute app qui re-rend l'intérieur du tiroir sans passer par renderContents
// (Dr Free Gift, Essential Upsell, etc.) fait perdre le listener.
// Délégation au niveau document = un seul écouteur qui survit à tous les re-rendus.
document.addEventListener('click', (event) => {
  if (!event.target.closest('#CartDrawer-Overlay')) return;
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.close === 'function') drawer.close();
});
